import React, { useEffect, useRef } from "react"

import { Link } from "gatsby"

export const BreadcrumbLink = ({ ressort, content, link, scroll_here }) => {
  const breadcrumbRef = useRef(null)
  useEffect(() => {
    if (scroll_here) {
      breadcrumbRef.current.parentNode.scrollLeft =
        breadcrumbRef.current.offsetLeft
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div
      ref={scroll_here ? breadcrumbRef : null}
      className="level-item help is-marginless"
    >
      <Link to={link} className={`link has-text-${ressort}`}>
        {content}
      </Link>
    </div>
  )
}
